import React from "react";
import AcceptAutoFinanceWrapper from "../AcceptAutoFinance.styles";
import { Paragraph } from "@components/paragraph";
import SectionHeading from "@components/sectionHeading";
import environmentSettings from "@src/constants/environmentSettings";

export default function SuccessDealerMessage() {
  const { phone } = environmentSettings;

  return (
    <AcceptAutoFinanceWrapper maxWidth="720px">
        <SectionHeading heading="Thank you! Your client wishes to proceed with their Car Loan Offer!"/>
        <Paragraph size="p0" textAlign="center">
            Their loan contract is being prepared and will be emailed to them shortly!
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        <strong>Once received, they will need to:</strong><br />
        open and view their contract &amp;<br />
        electronically sign it
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        To do this, they will need to enter the SECURITY CODE we have sent to their mobile number.
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        Once electronically signed, their loan funds can be disbursed!
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        If you need any assistance, please call us on <a href={`tel:${phone}`}>{phone}</a>.
        <br />
        Go forward with us!
        </Paragraph>
    </AcceptAutoFinanceWrapper>
  );
}
